import { Component } from 'react';
import { inject, observer } from 'mobx-react';
import propTypes from 'prop-types';

import { SingleItem } from '../../SingleItem/SingleItem';
import { SingleItemMobile } from '../../SingleItem/SingleItemMobile';

class _Items extends Component {
  render() {
    const { uiStore, group } = this.props;

    return (
      group.isShown
      && (
        <div className="cart-group__content">
          {group.selectCards.map((card) => (uiStore.isMobile
            ? <SingleItemMobile card={card} key={card.skuID} isEditable={false} extraClassName="group-item" />
            : <SingleItem card={card} key={card.skuID} isEditable={false} />))}
        </div>
      )
    );
  }
}

_Items.propTypes = {
  group: propTypes.shape({
    selectCards: propTypes.object,
    isShown: propTypes.bool
  }),

  uiStore: propTypes.shape({
    isMobile: propTypes.bool
  })
};

export const Items = inject('uiStore')(observer(_Items));
